import { useContext } from "react";
import { FormattedMessage } from "react-intl";
import Modal from "@/components/Modal";
import { ReactContext } from "@/app/providers/ReactContextProvider/react-context";

export const ModalError = () => {
  const { errorMessage, setErrorMessage } = useContext(ReactContext);
  const onCloseErrorModal = () => {
    setErrorMessage(null);
  };
  return (
    <Modal
      title={<FormattedMessage defaultMessage="Ошибка" />}
      show={!!errorMessage}
      onClose={onCloseErrorModal}
    >
      <p>{errorMessage}</p>
    </Modal>
  );
};
